<template>
    <div class="data-center">
        <div class="data-head">
            <div class="data-head-left">
                <div class="data-head-title"><i class="el-icon-s-promotion"></i>{{ $store.state.themeTitle }}室监控大屏
                </div>
                <div class="data-head-subtitle">万博云信大学</div>
            </div>
            <div class="data-head-center">
                <div class="data-head-tab">[实验室数据概览]</div>
            </div>
            <div class="data-head-right">
                <div class="data-head-title">
                    {{ currentTime }}
                </div>
                <div class="data-head-subtitle">{{ $until.getDateStr(new Date().getTime() / 1000) }}</div>
            </div>
        </div>
        <div class="data-body">
            <!-- <div class="data-zindex2">

            </div> -->
            <div class="data-zindex1">
                <div class="data-zindex1-left">
                    <div class="data-sub">
                        <div class="data-sub-title"> <i class="el-icon-full-screen"></i><span>{{ $store.state.themeTitle
                        }}室使用情况</span></div>
                        <div class="data-sub-content">
                            <el-table :data="centerData.uses" style="width: 100%;height: 100%;">
                                <el-table-column prop="date" label="实验室编号">
                                    <template slot-scope="scope">{{ scope.row.date }}</template>
                                </el-table-column>
                                <el-table-column prop="address" label="实验室名称">
                                </el-table-column>
                                <el-table-column prop="name" label="实训室负责人">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="data-sub">
                        <div class="data-sub-title"><i class="el-icon-full-screen"></i><span>{{ $store.state.themeTitle
                        }}室隐患情况</span></div>
                        <div class="data-sub-content ">
                            <el-table :data="centerData.danger" style="width: 100%;height: 100%;">
                                <el-table-column prop="date" label="实验室编号">
                                </el-table-column>
                                <el-table-column prop="name" label="实验室名称">
                                </el-table-column>
                                <el-table-column prop="address" label="隐患状态">
                                </el-table-column>
                            </el-table>

                        </div>
                    </div>
                </div>
                <div class="data-zindex1-center">
                    <div class="data-sub height-100">
                        <div class="data-tab">
                            <div class="data-tab-item">
                                <div class="data-tab-item-title">实验室数量</div>
                                <div class="data-tab-item-subtitle animate-num" keyy="syssl"><i
                                        class="el-icon-loading"></i></div>
                            </div>
                            <div class="data-tab-item">
                                <div class="data-tab-item-title">仪器设备库存数量</div>
                                <div class="data-tab-item-subtitle animate-num" keyy="yqsbkcsl"><i
                                        class="el-icon-loading"></i></div>
                            </div>
                            <div class="data-tab-item">
                                <div class="data-tab-item-title">实验耗材库存数量</div>
                                <div class="data-tab-item-subtitle animate-num" keyy="syhckcsl"><i
                                        class="el-icon-loading"></i></div>
                            </div>
                            <div class="data-tab-item">
                                <div class="data-tab-item-title">危化品库存数量</div>
                                <div class="data-tab-item-subtitle animate-num" keyy="whpkcsl"><i
                                        class="el-icon-loading"></i></div>
                            </div>
                            <div class="data-tab-item">
                                <div class="data-tab-item-title">专任实验室人员数量</div>
                                <div class="data-tab-item-subtitle animate-num" keyy="zrsysrysl"><i
                                        class="el-icon-loading"></i></div>
                            </div>
                        </div>
                        <div>
                            <div class="canvas-title">实验楼</div>
                            <ModelViewer model-path="/glb/test.glb" :height="400" :initial-scale="0.11"
                                :auto-rotate="true" @load="onModelLoad" @error="onModelError" />
                        </div>
                        <div style="height: calc(100% - 92px - 74px - 400px);">
                            <div class="data-sub-title"><i class="el-icon-full-screen"></i><span>仪器设备库存情况</span> <span
                                    class="text-right">数据统计日期：2025/04/01</span></div>
                            <div class="data-sub-content content-flex">
                                <div class="content-flex-left">
                                    <div class="card-item" style="background-color: #16c8be;">
                                        <div class="card-item-title">库存数量</div>
                                        <div class="card-item-number">3456</div>
                                    </div>
                                    <div class="card-item" style="background-color: #0bcc87;">
                                        <div class="card-item-title">采购数量</div>
                                        <div class="card-item-number">210</div>
                                    </div>
                                    <div class="card-item" style="background-color: #114499;">
                                        <div class="card-item-title">在用数量</div>
                                        <div class="card-item-number">3156</div>
                                    </div>
                                </div>
                                <div class="content-flex-right">
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                    <div class="line-item">
                                        <div class="line-item-title"><span><b>01</b>减速器</span><span
                                                class="line-right">库存数量：15&nbsp;&nbsp;在用数量：10&nbsp;</span></div>
                                        <div class="line-item-progress">
                                            <el-progress :percentage="50" color="#18FEF0"
                                                :show-text="false"></el-progress>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="data-zindex1-right">
                    <div class="data-sub">
                        <div class="data-sub-title"> <i class="el-icon-full-screen"></i><span>{{ $store.state.themeTitle
                        }}室分级情况</span></div>
                        <div class="data-sub-content">
                            <PieChart :data="pieData" :title="`${$store.state.themeTitle}室分级情况`" width="100%"
                                height="350px" @chart-click="onChartClick" />
                        </div>
                    </div>
                    
                    <div class="data-sub">
                        <div class="data-sub-title">{{ $store.state.themeTitle }}室分类情况</div>
                        <div class="data-sub-content">

                            <div class="data-sub-content">
                                <PieChart :data="pieData1" :title="`${$store.state.themeTitle}室分类情况`" width="100%"
                                    height="350px" @chart-click="onChartClick" />
                            </div>
                        </div>

                        <!-- <div class="data-sub-title">{{ $store.state.themeTitle }}室实时监控</div>
                    <div class="data-sub-content">

                    </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ModelViewer from './components/ModelViewer.vue';
import PieChart from './components/Pie.vue'


export default {
    name: 'dataCenter',
    components: {
        ModelViewer,
        PieChart,
    },
    data() {
        return {
            centerData: {
                tabData: { syssl: 28, yqsbkcsl: 456, syhckcsl: 14568, whpkcsl: 3456, zrsysrysl: 145 },
                uses: [{ date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                { date: '2016-05-02', name: '王小虎', address: '实验室01' },
                ],
                danger: [
                    { date: '2016-05-02', name: '王小虎', address: '需整改' },
                    { date: '2016-05-02', name: '王小虎', address: '优秀实验室' },
                    { date: '2016-05-02', name: '王小虎', address: '正常' },
                    { date: '2016-05-02', name: '王小虎', address: '需整改' },
                    { date: '2016-05-02', name: '王小虎', address: '优秀实验室' },
                    { date: '2016-05-02', name: '王小虎', address: '正常' },
                    { date: '2016-05-02', name: '王小虎', address: '需整改' },
                    { date: '2016-05-02', name: '王小虎', address: '优秀实验室' },
                    { date: '2016-05-02', name: '王小虎', address: '正常' },
                    { date: '2016-05-02', name: '王小虎', address: '需整改' },
                    { date: '2016-05-02', name: '王小虎', address: '优秀实验室' },
                    { date: '2016-05-02', name: '王小虎', address: '正常' },]

            },
            pieData: [
                {
                    value: 52,
                    name: "一级实验室",
                },
                {
                    value: 28,
                    name: "二级实验室",
                },
                {
                    value: 10,
                    name: "三级实验室",
                },
                {
                    value: 10,
                    name: "四级实验室",
                },
            ],
            pieData1: [
                {
                    value: 52,
                    name: "生物类",
                },
                {
                    value: 88,
                    name: "机电类",
                },
                {
                    value: 10,
                    name: "化学类",
                },
                {
                    value: 10,
                    name: "辐射类",
                },
                {
                    value: 33,
                    name: "其他类",
                },
            ],
            currentTime: '--:--:--'
        }
    },
    mounted() {
        const $ele = document.getElementsByClassName("animate-num")
        for (const ele of $ele) {
            this.animateNumber(ele, this.centerData.tabData[ele.getAttribute('keyy')])
        }
        this.updateTimeDisplay()
    },
    methods: {
        updateTimeDisplay() {
            setInterval(() => {
                const now = new Date();
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');
                const seconds = now.getSeconds().toString().padStart(2, '0');
                this.currentTime = `${hours}:${minutes}:${seconds}`;
                console.log(this.currentTime)
            }, 1000)
        },
        animateNumber(element, finalValue, duration = 2000, prefix = '', suffix = '') {
            let start = 0;
            const increment = finalValue / (duration / 16);
            const timer = setInterval(() => {
                start += increment;
                if (start >= finalValue) {
                    clearInterval(timer);
                    element.textContent = prefix + finalValue + suffix;
                } else {
                    element.textContent = prefix + Math.floor(start) + suffix;
                }
            }, 16);
        },
        onModelLoad(gltf) {
            // this.$message.success('3D模型加载完成');
            console.log('加载成功', gltf);
        },
        onChartClick() {

        },
        onModelError(error) {
            this.$message.error(`加载失败: ${error.message}`);
            console.error('加载错误', error);
        }
    }

}
</script>

<style lang="less" scoped src="./less/center.less"></style>
